import React from 'react'
import CountUp from 'react-countup'
import Loader from 'react-loader-spinner'

function DataCard({IsLoading, Title, Data, color}) {
  const findRate = (newValue, totalValue) => {
    return (newValue * 100) / totalValue
  }
  return (
    <React.Fragment>
      <div className="child-container m-4">
        <div className="label">{Title}</div>
        {!IsLoading ? (
          <div className="text">
            {!Data[0] ? null : (
              <div className="new-cases">
                <CountUp end={Data[0]} prefix="↑" duration={2} separator="," />
              </div>
            )}
            <CountUp end={Data[1]} duration={2} separator="," />
            {!Data[0] ? null : (
              <div className="rate">
                <CountUp
                  end={findRate(Data[0], Data[1])}
                  duration={2}
                  separator=","
                  decimals={2}
                  suffix="%"
                />
              </div>
            )}
          </div>
        ) : (
          <Loader type="Circles" color={color} height={30} width={30} />
        )}
      </div>
    </React.Fragment>
  )
}

export default DataCard
